export const portalExamplePluginToken = Symbol('portal-example-plugin');
export const cadastralMapModuleToken = Symbol('module-cadastral-map');
